<template>
  <div class="page overflow-auto">
    <AdminMixerRequestDetailView />
  </div>
</template>

<script>
import AdminMixerRequestDetailView from '../../../views/admin/mixer-requests/AdminMixerRequestDetailView';
export default {
  name: 'AdminMixerRequestDetailPage',
  components: { AdminMixerRequestDetailView },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
